import { useEffect } from 'react';
import { useTimezone } from '../../shared/contexts/TimezoneContext';
import { useBookingStore } from '../store/useBookingStore';

/**
 * Syncs the user's IANA timezone identifier to a hidden DOM input when
 * "Show times in user's timezone" is enabled.
 *
 * Populates: input_{formId}_{fieldId}_user_timezone
 */
export function useUserTimezoneSync(formId: number, fieldId: number): void {
	const showUserTimezone = useBookingStore((state) => state.showUserTimezone);
	const { localTimezone } = useTimezone();

	useEffect(() => {
		if (!showUserTimezone) {
			return;
		}

		const tzInput = document.getElementById(
			`input_${formId}_${fieldId}_user_timezone`
		) as HTMLInputElement | null;

		if (!tzInput) {
			return;
		}

		tzInput.value = localTimezone;
	}, [showUserTimezone, localTimezone, formId, fieldId]);
}
